module.exports = __webpack_public_path__ + "static/media/PLAY.17691fdb.svg";